import { Card } from '@/components/ui/card';
import { Heart, Brain, Dna, ShieldCheck, Activity } from 'lucide-react';

interface Pillar {
  name: string;
  score: number;
  icon: React.ReactNode;
  color: string;
}

interface PillarsScoreProps {
  scores: {
    cardio: number;
    lifestyle: number;
    mental: number;
    preventive: number;
    engagement: number;
  };
}

export const PillarsScore = ({ scores }: PillarsScoreProps) => {
  const pillars: Pillar[] = [
    { name: 'Cardio', score: scores?.cardio ?? 0, icon: <Heart size={24} />, color: 'text-red-500' },
    { name: 'Lifestyle', score: scores?.lifestyle ?? 0, icon: <Activity size={24} />, color: 'text-green-500' },
    { name: 'Mental', score: scores?.mental ?? 0, icon: <Brain size={24} />, color: 'text-blue-500' },
    { name: 'Preventive', score: scores?.preventive ?? 0, icon: <ShieldCheck size={24} />, color: 'text-purple-500' },
    { name: 'Engagement', score: scores?.engagement ?? 0, icon: <Dna size={24} />, color: 'text-yellow-500' },
  ];

  const getScoreColor = (score: number) => {
    if (score >= 120) return 'bg-green-500'; // A
    if (score >= 90) return 'bg-lime-500'; // B
    if (score >= 60) return 'bg-yellow-500'; // C
    if (score >= 30) return 'bg-orange-500'; // D
    return 'bg-red-500'; // E
  };

  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Actionable Health Pillars</h3>
      <div className="space-y-4">
        {pillars.map((pillar) => (
          <div key={pillar.name} className="flex items-center">
            <div className={`mr-4 ${pillar.color}`}>
              {pillar.icon}
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-center mb-1">
                <span className="font-medium">{pillar.name}</span>
                <span className={`font-semibold ${pillar.color}`}>{pillar.score} / 150</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div 
                  className={`h-2.5 rounded-full ${getScoreColor(pillar.score)}`}
                  style={{ width: `${(pillar.score / 150) * 100}%` }}
                ></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}; 